import PropTypes from "prop-types";
import { fromPricing } from "helpers/formatting";
import LinkSmooth from "components/shared/stays/LinkSmooth";
import Button from "solar/components/Button";
import IconLightning from "solar/icons/IconLightning";
import MessageButton from "components/shared/stays/MessageButton";
import Message from "components/shared/stays/Message";
import styles from "components/stay/Actions.module.scss";

export default function Actions({
  lowestPrice,
  lowestPricingType,
  tripID,
  tripName,
  guideID,
  guidePrimaryEmployeeFirstName,
  guidePrimaryEmployeeImageUrl,
  closestTrips = [],
  instantlyBookable = false,
  responseTime = null,
}) {
  return (
    <div className={styles.component}>
      {lowestPrice && lowestPricingType && (
        <div className={styles.price}>
          {fromPricing(lowestPrice, lowestPricingType)}
        </div>
      )}
      <div className={styles.ctas}>
        {instantlyBookable ? (
          <>
            <LinkSmooth to="availability">
              <Button block icon={<IconLightning />}>
                Book instantly
              </Button>
            </LinkSmooth>
            {guideID && (
              <Message
                tripID={tripID}
                tripName={tripName}
                guideID={guideID}
                guidePrimaryEmployeeFirstName={guidePrimaryEmployeeFirstName}
                guidePrimaryEmployeeImageUrl={guidePrimaryEmployeeImageUrl}
                responseTime={responseTime}
              >
                <Button link className={styles.link}>
                  Message {guidePrimaryEmployeeFirstName}
                </Button>
              </Message>
            )}
          </>
        ) : (
          <>
            {guideID && (
              <Message
                tripID={tripID}
                tripName={tripName}
                guideID={guideID}
                guidePrimaryEmployeeFirstName={guidePrimaryEmployeeFirstName}
                guidePrimaryEmployeeImageUrl={guidePrimaryEmployeeImageUrl}
                closestTrips={closestTrips}
                responseTime={responseTime}
                key={tripID}
              >
                <MessageButton
                  guidePrimaryEmployeeFirstName={guidePrimaryEmployeeFirstName}
                  guidePrimaryEmployeeImageUrl={guidePrimaryEmployeeImageUrl}
                />
              </Message>
            )}
            <LinkSmooth to="availability">
              <Button link className={styles.link}>
                Check availability
              </Button>
            </LinkSmooth>
          </>
        )}
      </div>
    </div>
  );
}

Actions.propTypes = {
  lowestPrice: PropTypes.string.isRequired,
  lowestPricingType: PropTypes.string.isRequired,
  tripID: PropTypes.string.isRequired,
  tripName: PropTypes.string.isRequired,
  guideID: PropTypes.string.isRequired,
  guidePrimaryEmployeeFirstName: PropTypes.string.isRequired,
  guidePrimaryEmployeeImageUrl: PropTypes.string.isRequired,
  instantlyBookable: PropTypes.bool,
  responseTime: PropTypes.number,
  closestTrips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      country: PropTypes.string,
      lowest_price: PropTypes.node,
      product_type: PropTypes.string,
      trip_type_description: PropTypes.string,
      is_featured: PropTypes.bool,
      image_url: PropTypes.string,
      distance: PropTypes.number,
    })
  ),
};
